import { render, staticRenderFns } from "./LoginPageWrapper.vue?vue&type=template&id=4a8115de&scoped=true&"
import script from "./LoginPageWrapper.vue?vue&type=script&lang=js&"
export * from "./LoginPageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageWrapper.vue?vue&type=style&index=0&id=4a8115de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8115de",
  null
  
)

export default component.exports